import { MenuOption } from '../types';
import { ReportContentItemsKey } from '../types/report';

export enum GenerateStatus {
  Failure = 'fail',
  TakePdfFailure = 'fail:takePdf',
  UploadFailure = 'fail:upload',
  //SendMailFailure = 'fail:sendMail',
  UpdateHistoryFailure = 'fail:updateHistory',
  //SaveStatusFailure = 'fail:saveStatus',
  //DeleteFilesFailure = 'fail:deleteFiles',
  InProgress = 'progress',
  Successful = 'success',
}
export enum TargetType {
  UserAndGroup = 'user',
  Domain = 'domain',
  HPU = 'hpu',
  Objects = 'object',
  Profiles = 'profile',
  Communities = 'community',
}
export enum DataPeriod {
  LastDay = 'last_1D',
  LastWeek = 'last_1W',
  LastMonth = 'last_1M',
  Last6Months = 'last_6M',
  LastYear = 'last_1Y',
}

export enum IntervalType {
  Hour = 'hour',
  Day = 'day',
  Month = 'month',
}

export enum Frequency {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
}

export const EXPORT_REPORT_TYPE = [
  {
    key: 'oneTime',
    value: 'reportCommon.enums.exportType.oneTime',
  },
  {
    key: 'scheduled',
    value: 'reportCommon.enums.exportType.scheduled',
  },
  {
    key: 'manualScan',
    value: 'reportCommon.enums.exportType.manualScan',
  },
  {
    key: 'dashboardReport',
    value: 'reportCommon.enums.exportType.dashboardReport',
  },
  {
    key: 'riskAI',
    value: 'reportCommon.enums.exportType.riskAI',
  },
];

export const DATA_PERIOD_LIST: DataPeriod[] = [
  DataPeriod.LastDay,
  DataPeriod.LastWeek,
  DataPeriod.LastMonth,
  DataPeriod.Last6Months,
  DataPeriod.LastYear,
];
export const DATA_PERIOD_MAP: { [key in DataPeriod]: string } = {
  [DataPeriod.LastDay]: 'reportCommon.period.last1D',
  [DataPeriod.LastWeek]: 'reportCommon.period.last1W',
  [DataPeriod.LastMonth]: 'reportCommon.period.last1M',
  [DataPeriod.Last6Months]: 'reportCommon.period.last6M',
  [DataPeriod.LastYear]: 'reportCommon.period.last1Y',
};

export const CUSTOM_DATA_PERIOD_MAP: { [key in IntervalType]: string } = {
  [IntervalType.Hour]: 'reportCommon.period.hour',
  [IntervalType.Day]: 'reportCommon.period.day',
  [IntervalType.Month]: 'reportCommon.period.month',
};

export const SCHEDULE_FREQUENCY = [
  {
    key: Frequency.Daily,
    value: 'reportCommon.enums.scheduleFrequency.day',
  },
  {
    key: Frequency.Weekly,
    value: 'reportCommon.enums.scheduleFrequency.week',
  },
  {
    key: Frequency.Monthly,
    value: 'reportCommon.enums.scheduleFrequency.month',
  },
];
export const SCHEDULE_FREQUENCY_TIP = [
  {
    key: Frequency.Daily,
    value: 'reportCommon.tips.hints.frequencyDaily',
  },
  {
    key: Frequency.Weekly,
    value: 'reportCommon.tips.hints.frequencyWeekly',
  },
  {
    key: Frequency.Monthly,
    value: 'reportCommon.tips.hints.frequencyMonthly',
  },
];

export const WEEK_DAY: MenuOption[] = [
  {
    key: '1',
    value: 'reportCommon.enums.weekday.monday',
  },
  {
    key: '2',
    value: 'reportCommon.enums.weekday.tuesday',
  },
  {
    key: '3',
    value: 'reportCommon.enums.weekday.wednesday',
  },
  {
    key: '4',
    value: 'reportCommon.enums.weekday.thursday',
  },
  {
    key: '5',
    value: 'reportCommon.enums.weekday.friday',
  },
  {
    key: '6',
    value: 'reportCommon.enums.weekday.saturday',
  },
  {
    key: '7',
    value: 'reportCommon.enums.weekday.sunday',
  },
];

export const MONTH_DAY: MenuOption[] = [
  { key: '1', value: '1' },
  { key: '2', value: '2' },
  { key: '3', value: '3' },
  { key: '4', value: '4' },
  { key: '5', value: '5' },
  { key: '6', value: '6' },
  { key: '7', value: '7' },
  { key: '8', value: '8' },
  { key: '9', value: '9' },
  { key: '10', value: '10' },
  { key: '11', value: '11' },
  { key: '12', value: '12' },
  { key: '13', value: '13' },
  { key: '14', value: '14' },
  { key: '15', value: '15' },
  { key: '16', value: '16' },
  { key: '17', value: '17' },
  { key: '18', value: '18' },
  { key: '19', value: '19' },
  { key: '20', value: '20' },
  { key: '21', value: '21' },
  { key: '22', value: '22' },
  { key: '23', value: '23' },
  { key: '24', value: '24' },
  { key: '25', value: '25' },
  { key: '26', value: '26' },
  { key: '27', value: '27' },
  { key: '28', value: '28' },
  { key: '29', value: '29' },
  { key: '30', value: '30' },
  { key: '31', value: '31' },
];

export const TEMPLATE_LIST: MenuOption[] = [
  {
    key: 'overall threat detections',
    value: 'dashboard.tabs.threatDetection',
  },
  // { key: 'Ransomware', value: 'dashboard.sideBar.ransomware' },
  // {
  //   key: 'Business Email Compromise (BEC)',
  //   value: 'dashboard.sideBar.bec',
  // },
  // { key: 'Security Risk Scan', value: 'dashboard.sideBar.securityRisk' },
  // { key: 'Summary', value: 'dashboard.sideBar.summary' },
  // {
  //   key: 'Virtual Analyzer for Suspicious Objects',
  //   value: 'dashboard.sideBar.virtualAnalyzer',
  // },
  // { key: 'Data Loss Prevention', value: 'dashboard.sideBar.dlp' },
  // { key: 'Advanced Threat Protection', value: 'dashboard.sideBar.atp' },
  // { key: 'Anomaly Detection', value: 'dashboard.sideBar.anomaly' },
];

export const REPORT_CONTENT_ITEMS: ReportContentItemsKey[] = [
  'total',
  'bec',
  'phishing',
  'ransomware',
  'maliciousFile',
  'maliciousURL',
  'spoofing',
  'spam',
  'anomaly',
  'dlp',
];

export enum ThreatType {
  'BEC' = 'BEC',
  'Spoofing' = 'Spoofing',
  'Phishing' = 'Phishing',
  'MaliciousFile' = 'Malicious File',
  'MaliciousURL' = 'Malicious URL',
  'Ransomware' = 'Ransomware',
  'Spam' = 'Spam',
  'DLP' = 'DLP',
  'Blocked' = 'Blocked',
  'UntestedOrUnscannable' = 'UntestedOrUnscannable',
  'ActiveContent' = 'Active Content',
  'SuspiciousObjectType' = 'Suspicious Object',
  'Anomaly' = 'Anomaly',
  'Scam' = 'Spoofing',
}

export enum BannerType {
  ConnectedSolution = 'connectBanner',
  SolutionUpgrade = 'upgradeBanner',
  Flywheel = 'flywheelBanner',
  V1ForEveryone = 'v1ForEveryone',
}

export enum ConsoleType {
  NewConsole = 'NewConsole',
  ClassicConsole = 'ClassicConsole',
}

export enum GlobalCustomEvent {
  FreshGlobalSetting = 'FreshGlobalSetting',
}
